
import Vue from "vue";
import api from "@/services/conexao-api.js";

export default Vue.extend({
  data() {
    return {
      username: "",
      password: "",
      showPassword: false,
      token: "",
    };
  },
  computed: {
    usernameRules() {
      return [this.$rules.required("Nome")];
    },
    passwordRules() {
      return [this.$rules.required("Senha")];
    },
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    validateUsername() {
      (this.$refs.usernameField as any).validate();
    },
    validatePassword() {
      (this.$refs.passwordField as any).validate();
    },
    async login() {
      const form = this.$refs.loginForm as any;

      if (form && form.validate()) {
        try {
          const token = await api
            .post("/auth/attendance", {
              username: this.username,
              password: this.password,
            })
            .then((response) => response.data);

          if (token) {
            this.$store.dispatch("saveToken", token);
            this.$router.push("/");
          } else {
            this.$toast.error("Usuário ou senha inválidos!");
          }
        } catch (error) {
          this.$toast.error(
            "Ocorreu um erro ao tentar fazer login no sistema de atendimento."
          );
        }
      }
    },
  },
});
